export default "__VITE_PUBLIC_ASSET__ab418308__"